// Disabling this since the props spread should contain `children
// Not adding children explicitly to avoid unintentionally changing the API of this component
// Ideally, children would be marked as required on this component
/* eslint-disable jsx-a11y/anchor-has-content */ import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiLink = (_param)=>{
    var { biData , dispatch , innerRef , stopPropagation  } = _param, props = _object_without_properties(_param, [
        "biData",
        "dispatch",
        "innerRef",
        "stopPropagation"
    ]);
    const { setTrackingRef  } = useBiClickLogger(biData, stopPropagation);
    if (props.target === '_blank' && !props.rel) {
        props.rel = 'noreferrer';
    }
    return /*#__PURE__*/ React.createElement("a", _extends({}, props, {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiLink.displayName = 'BiLink';
export default BiLink;
